import React, { type FC, useEffect, useRef, useState } from 'react';

import { createPortal } from 'react-dom';

import { handlePageTabIndex } from '../../utils';
import type { IDialogProps } from './dialog.props';
import { StyledDialog, StyledDialogBackdrop, StyledDialogWrapper } from './dialog.styles';

export const Dialog: FC<IDialogProps> = (props) => {
  const { open: open, children, onOpen, onClose, ...otherProps } = props;

  const [firstOpen, setFirstOpen] = useState<boolean>(false);
  const [initialShow, setInitialShow] = useState<boolean>(open);
  const [fadeDialog, setFadeDialog] = useState<boolean>(false);

  const dialogId = useRef(crypto.randomUUID());

  useEffect(() => {
    onOpen && onOpen();
  }, [fadeDialog]);

  useEffect(() => {
    if (open) {
      setInitialShow(true);
      requestAnimationFrame(() => {
        const timer = setTimeout(() => {
          setFadeDialog(true);
          setFirstOpen(true);
          const wrapper = document.querySelector(`[data-dialog-wrapper='${dialogId.current}']`);
          handlePageTabIndex(true, wrapper);
        }, 50);

        return () => clearTimeout(timer);
      });
    } else {
      setFadeDialog(false);

      if (firstOpen) {
        handlePageTabIndex(false);
      }

      const timer = setTimeout(() => {
        setInitialShow(false);
      }, 360);

      return () => clearTimeout(timer);
    }
  }, [open]);

  return createPortal(
    initialShow && (
      <StyledDialogWrapper $open={fadeDialog} data-dialog-wrapper={dialogId.current}>
        <StyledDialog {...otherProps}>{children}</StyledDialog>
        <StyledDialogBackdrop onClick={onClose} />
      </StyledDialogWrapper>
    ),
    document.body
  );
};
